import { supabase } from './supabase';

export const getProjectProfile = async (projectId) => {
  try {
    const { data: profile, error } = await supabase
      .from('project_profiles')
      .select(`
        business_name,
        industry,
        products_offered,
        products_not_offered,
        business_goals,
        unique_selling_points,
        key_competitors,
        brand_voice,
        geographic_focus,
        primary_country,
        regions,
        cities,
        international,
        language,
        website_url
      `)
      .eq('project_id', projectId)
      .single();

    if (error) {
      console.error('Error fetching project profile:', error);
      throw error;
    }

    if (!profile) {
      console.warn('No profile found for project:', projectId);
      return null;
    }

    // Format the profile data into a descriptive string
    const profileString = `
Business Profile:
Company: ${profile.business_name}
Industry: ${profile.industry}
Website: ${profile.website_url || 'Not specified'}

Products & Services:
- Offered: ${profile.products_offered?.join(', ') || 'None specified'}
- Not Offered: ${profile.products_not_offered?.join(', ') || 'None specified'}

Business Goals:
${JSON.stringify(profile.business_goals, null, 2)}

Unique Selling Points:
${profile.unique_selling_points?.map(usp => `- ${usp}`).join('\n') || 'None specified'}

Brand Voice:
${profile.brand_voice || 'Not specified'}

Geographic Presence:
- Primary Country: ${profile.primary_country || 'Not specified'}
- Regions: ${profile.regions?.join(', ') || 'None specified'}
- Cities: ${profile.cities?.join(', ') || 'None specified'}
- International: ${profile.international ? 'Yes' : 'No'}

Key Competitors:
${profile.key_competitors?.map(comp => `- ${JSON.stringify(comp)}`).join('\n') || 'None specified'}

Geographic Focus:
${JSON.stringify(profile.geographic_focus, null, 2)}

Content Language: ${profile.language || 'en'}
    `.trim();

    return profileString;

  } catch (error) {
    console.error('Error in getProjectProfile:', error);
    throw new Error(`Failed to get project profile: ${error.message}`);
  }
};

export const getProjectProfileString = async (projectId) => {
  try {
    const { data: profile, error } = await supabase
      .from('project_profiles')
      .select(`
        business_name,
        industry,
        products_offered,
        products_not_offered,
        business_goals,
        unique_selling_points,
        key_competitors,
        brand_voice,
        geographic_focus,
        primary_country,
        regions,
        cities,
        international,
        language,
        website_url
      `)
      .eq('project_id', projectId)
      .single();

    if (error) {
      console.error('Error fetching project profile:', error);
      throw error;
    }

    if (!profile) {
      console.warn('No profile found for project:', projectId);
      return null;
    }

    // Format the profile data into a flat string without JSON structures
    const profileString = `Business Profile - Company: ${profile.business_name}. Industry: ${profile.industry}. Website: ${profile.website_url || 'Not specified'}. Products & Services - Offered: ${profile.products_offered?.join(', ') || 'None specified'}. Not Offered: ${profile.products_not_offered?.join(', ') || 'None specified'}. Business Goals: ${profile.business_goals ? Object.entries(profile.business_goals).map(([key, value]) => `${key}: ${value}`).join(', ') : 'None specified'}. Unique Selling Points: ${profile.unique_selling_points?.join(', ') || 'None specified'}. Brand Voice: ${profile.brand_voice || 'Not specified'}. Geographic Presence - Primary Country: ${profile.primary_country || 'Not specified'}. Regions: ${profile.regions?.join(', ') || 'None specified'}. Cities: ${profile.cities?.join(', ') || 'None specified'}. International: ${profile.international ? 'Yes' : 'No'}. Key Competitors: ${profile.key_competitors ? profile.key_competitors.map(comp => comp.toString()).join(', ') : 'None specified'}. Geographic Focus: ${profile.geographic_focus ? Object.entries(profile.geographic_focus).map(([key, value]) => `${key}: ${value}`).join(', ') : 'None specified'}. Content Language: ${profile.language || 'en'}`.replace(/\n/g, ' ');

    return profileString;

  } catch (error) {
    console.error('Error in getProjectProfileString:', error);
    throw new Error(`Failed to get project profile: ${error.message}`);
  }
};